'use client';

import { I18nextProvider } from 'react-i18next';
import initTranslations from '@/lib/i18n/i18n';
import { createInstance, Resource } from 'i18next';
import { ReactNode, useEffect } from 'react';
import { Locales } from '@/types/i18n';
import clientI18n from '@/lib/i18n/client';

interface TranslationsProviderProps {
  children: ReactNode;
  locale: Locales;
  namespaces: string[];
  resources: Resource;
}

export default function TranslationsProvider({
  children,
  locale,
  namespaces,
  resources,
}: TranslationsProviderProps) {
  // For server components, we need a new instance with the resources
  const i18n = createInstance();
  
  // Initialize the server instance
  initTranslations(locale, namespaces, i18n, resources);
  
  // Update client instance language when locale changes
  useEffect(() => {
    if (clientI18n.language !== locale) {
      clientI18n.changeLanguage(locale);
    }
    
    // Also update resources in the client instance
    if (resources) {
      Object.entries(resources).forEach(([lng, namespaceResources]) => {
        Object.entries(namespaceResources).forEach(([ns, nsResources]) => {
          clientI18n.addResourceBundle(lng, ns, nsResources, true, true);
        });
      });
    }
  }, [locale, resources]);
  
  // Use the client instance for client components
  return <I18nextProvider i18n={clientI18n}>{children}</I18nextProvider>;
}
